<template>
  <div class="input-group flex-column">
    <div class="form-floating filter-input overflow-hidden">
      <input
        v-if="hasTextFilter(column)"
        v-model="localFilter[column]"
        :class="getElementClass(column)"
        class="form-control"
        type="text"
        @keyup="filterModelsBy(column, route(`${routePrefix}.${resourceType}.adjust`))"
      />
      <label v-if="hasTextFilter(column)" :for="resourceType + '-filter-' + column">
        {{ resource.meta.labels[column] }}
      </label>

      <select
        v-if="meta.listed[column] === 'tags' && meta.tags?.length"
        v-model="localFilter[column]"
        :class="getElementClass(column)"
        :value="value ?? ''"
        class="form-select"
        @change="filterModelsBy(column, route(`${routePrefix}.${resourceType}.adjust`))"
      >
        <option value="">(alle)</option>
        <option v-for="(tag, key) in meta.tags" :key="key" :value="tag.name.de">
          {{ tag.name.de }}
        </option>
      </select>

      <div v-if="meta.listed[column] === 'datetime' || meta.listed[column] === 'date'" class="form-control p-0">
        <label class="column-name p-0 ps-1 fw-bold">{{ resource.meta.labels[column] }}</label>
        <div class="row gap-1 m-0 w-100 flex-nowrap" style="font-size: 0.8125rem">
          <div class="col-12 p-0 ps-1 small d-flex">
            <label :for="resourceType + '-filter-' + column + '-min'" class="flex-0 p-0">Von:</label>
            <input
              :id="resourceType + '-filter-' + column + '-min'"
              v-model="localFilter[column]['min']"
              :class="getElementClass(column + '-min')"
              :placeholder="column"
              class="small w-100 border-0 flex-grow-1 p-0"
              type="date"
              @change="filterModelsBy(column, route(`${routePrefix}.${resourceType}.adjust`))"
            />
          </div>
        </div>
        <div class="row gap-1 m-0 w-100 flex-nowrap" style="font-size: 0.8125rem">
          <div class="col-12 p-0 ps-1 small d-flex">
            <label :for="resourceType + '-filter-' + column + '-max'" class="flex-0 p-0">Bis:</label>
            <input
              :id="resourceType + '-filter-' + column + '-max'"
              v-model="localFilter[column]['max']"
              :class="getElementClass(column + '-max')"
              :placeholder="column"
              class="small w-100 border-0 flex-grow-1 p-0"
              type="date"
              @change="filterModelsBy(column, route(`${routePrefix}.${resourceType}.adjust`))"
            />
          </div>
        </div>
      </div>

      <select
        v-if="meta.listed[column] === 'enum'"
        :id="resourceType + '-filter-' + column"
        v-model="localFilter[column]"
        :class="getElementClass(column)"
        :value="value ?? ''"
        class="form-select"
        @change="filterModelsBy(column, route(`${routePrefix}.${resourceType}.adjust`))"
      >
        <option value="">alle</option>
        <option :value="'NULL'">(leer)</option>
        <option v-for="(option, index) in meta.options[column]" :key="index" :value="option.value">
          {{ option.text }}
        </option>
      </select>
      <label
        v-if="meta.listed[column] === 'enum'"
        class="p-0 ps-1 pt-2 fw-bold"
        :for="resourceType + '-filter-' + column"
      >
        {{ resource.meta.labels[column] }}
      </label>
    </div>
    <!--    <div class="input-group-append">-->
    <!--      <span class="input-group-text h-100">-->
    <!--        <i class="bi bi-search"></i>-->
    <!--      </span>-->
    <!--    </div>-->
  </div>
  <!--  <div-->
  <!--    :class="excludeNull && excludeNull[column] ? 'text-primary' : 'text-inactive'"-->
  <!--    class="flex-column position-relative flex-grow-0 ps-0"-->
  <!--    style="cursor: pointer"-->
  <!--    @click="toggleExcludeNull(column, route(`${routePrefix}.${resourceType}.adjust`))"-->
  <!--  >-->
  <!--    <i class="bi bi-file" style="font-size: 1.75rem"></i>-->
  <!--    <div class="position-absolute top-0 left-0 ms-2 mt-2" style="font-size: 1.125rem">Ø</div>-->
  <!--  </div>-->
</template>

<script>
import { router } from '@inertiajs/vue3';
import _ from 'lodash';
import useResource from '@kanrisha/composables/useResource';
import useResourceParams from '@kanrisha/composables/useResourceParams';

export default {
  props: {
    resource: { type: Object, default: () => {} },
    column: { type: String, default: '' },
    options: { type: Object, default: () => {} },
    value: { type: [String, Number, Object], default: null },
    label: { type: String, default: '' },
  },
  emits: ['update:params'],
  setup(props, { emit }) {
    const { adjustments, meta, resourceType } = useResource(props, props.resource);
    const { localExcludeNull, localFilter, localSort } = useResourceParams(props);
    const filter = localFilter;
    const sort = localSort;
    const excludeNull = localExcludeNull;

    const filterModelsBy = _.debounce(function (column, url) {
      emit('update:params', getParams());
      router.get(url, getParams(), {
        preserveState: false,
        // only: ['models'],
        replace: true,
      });
    }, 500);

    const toggleExcludeNull = (column, url) => {
      let params = getParams();
      params['excludeNull'][column] = !localExcludeNull.value[column];
      emit('update:params', params);
      router.get(url, params, {
        preserveState: true,
        // only: ['models'],
        replace: true,
      });
    };

    const getParams = () => {
      return {
        sort: localSort.value,
        filter: localFilter.value,
        relation: props.options?.relation?.name,
        parent: props.options?.relation?.parentType,
      };
    };

    const hasTextFilter = (column) => {
      return (
        meta.value.columns[column] === 'text' ||
        meta.value.columns[column] === 'varchar' ||
        meta.value.columns[column] === 'decimal' ||
        meta.value.columns[column] === 'double' ||
        meta.value.columns[column] === 'int' ||
        meta.value.listed[column] === 'relation' ||
        meta.value.listed[column] === 'belongs-to'
      );
    };

    const getElementClass = (column) => {
      return resourceType.value + '_filter_' + column;
    };

    return {
      adjustments,
      excludeNull,
      filter,
      getElementClass,
      hasTextFilter,
      meta,
      sort,
      resourceType,
      localFilter,
      filterModelsBy,
      toggleExcludeNull,
    };
  },
};
</script>
